import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';

import CopyIcon from '@ad-scripts/presentation/components/common/icons/copy';
import Textarea from 'src/presentation/components/forms/Textarea';
import { toastError, toastSuccess } from 'src/actions/toast';

type SnippetProps = {
  text: string;
  dataAid: string;
};

const Snippet = ({ text, dataAid }: SnippetProps) => {
  const dispatch = useDispatch();

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(text);
      dispatch(toastSuccess('You’ve successfully copied the embed text'));
    } catch (e) {
      dispatch(toastError('Clipboard copying failed'));
    }
  };

  return (
    <Container data-aid={`${dataAid}.container`}>
      <ButtonContainer>
        <Button data-aid={`${dataAid}.button`} onClick={copyToClipboard} />
      </ButtonContainer>
      <Source value={text} data-aid={`${dataAid}.source`} />
    </Container>
  );
};

const Container = styled.div`
  position: relative;
`;

const ButtonContainer = styled.div`
  cursor: pointer;
`;

const Button = styled(CopyIcon)`
  position: absolute;
  right: 9px;
  bottom: 11px;
  width: 16px;
  height: 16px;
  fill: ${p => p.theme.colors.gray800};
`;

const Source = styled(Textarea)`
  font-family: 'Courier New', Courier, monospace;
  white-space: pre;
  height: 80px !important;
`;

export default Snippet;
